import React from "react";
import { useParams, Link } from "react-router-dom";
import { Calendar, Clock, ArrowLeft, ArrowRight } from "lucide-react";
import { blogPosts } from "../mock/mock";
import { PageHero, CTABanner } from "../components/Common";
import Blog from "./Blog";

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);
  if (!post) return <Blog />;
  const related = blogPosts.filter((p) => p.slug !== slug).slice(0, 3);

  return (
    <div>
      <PageHero eyebrow={post.category} title={post.title} image={post.image} />

      <article className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-bold text-gold-dark mb-8">
            <ArrowLeft size={16} /> Back to blog
          </Link>
          <div className="flex items-center gap-4 text-xs text-muted-foreground mb-8 pb-8 border-b border-border">
            <span className="flex items-center gap-1.5"><Calendar size={14} /> {post.date}</span>
            <span className="flex items-center gap-1.5"><Clock size={14} /> {post.readTime}</span>
          </div>
          <p className="text-lg text-navy font-medium leading-relaxed mb-6">{post.excerpt}</p>
          <div className="space-y-5 text-muted-foreground leading-relaxed">
            {post.body.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>
        </div>
      </article>

      <section className="bg-secondary py-16">
        <div className="max-w-7xl mx-auto px-6">
          <h3 className="font-heading font-extrabold text-navy text-2xl mb-8">Related articles</h3>
          <div className="grid md:grid-cols-3 gap-6">
            {related.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white rounded-2xl overflow-hidden border border-border card-lift">
                <div className="img-zoom h-40">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-5">
                  <h4 className="font-heading font-bold text-navy text-sm leading-snug mb-2 group-hover:text-navy-light transition-colors">{p.title}</h4>
                  <span className="inline-flex items-center gap-1 text-xs font-bold text-gold-dark">Read more <ArrowRight size={13} /></span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
};

export default BlogPost;
